import React, { useEffect } from "react";
import { motion } from "framer-motion";
import webdev from "../img/web-development.png";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import LearningBoy from "../img/File bundle-pana.png";
import Programmer from "../img/Programmer-cuate.png";
import CourseDetail from "../components/CoursesDetail";
import CourseDetail12 from "../components/CourseDetail12";
import NEWWEB from "../img/NEWWEB3.png";
import CoursesContentIcon from "../components/CoursesContentIcon";

const WebDev = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["2022網頁全端攻略"],
      speed: 100,
      startDelay: 2600,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element3", {
      strings: ["2026 網頁全端開發"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element3");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "你需要的唯一網頁開發課程 - 65小時學會前端與後端知識，包含HTML, CSS, JavaScript, ES6, Node.js, Express, SQL, MongoDB, Mongoose數據庫，動手開發專業網站，成為網頁全端工程師。",
      speed: 15,
      startDelay: 3700,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element4", {
      strings:
        "超過80小時的內容，學習HTML, CSS, JavaScript, React, Next.js 以及 NodeJS, Express, MongoDB, Restful API，透過9個實作專案豐富作品集，透徹學習網頁開發的知識與技巧!",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element4");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={NEWWEB} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element3"></span>
          </h1>
          <div className="content">
            <h3 id="element4"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={
                  "https://www.udemy.com/course/wilson-full-stack-web-development/?couponCode=" +
                  process.env.REACT_APP_2026_WEB_COUPON
                }
              >
                <span>{process.env.REACT_APP_2026_WEB_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={
                  "https://www.udemy.com/course/wilson-full-stack-web-development/?couponCode=" +
                  process.env.REACT_APP_2026_WEB_COUPON
                }
              >
                <span className="hide">
                  https://www.udemy.com/course/wilson-full-stack-web-development/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/1765/about
            </p> */}
          </div>
        </div>
      </motion.div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={webdev} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={
                  "https://www.udemy.com/course/html5-css3-z/?couponCode=" +
                  process.env.REACT_APP_2022_WEB_COUPON
                }
              >
                <span>{process.env.REACT_APP_2022_WEB_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={
                  "https://www.udemy.com/course/html5-css3-z/?couponCode=" +
                  process.env.REACT_APP_2022_WEB_COUPON
                }
              >
                <span className="hide">
                  https://www.udemy.com/course/html5-css3-z/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/571/about
            </p> */}
          </div>
        </div>
        <CoursesContentIcon />
        <CourseDetail img={LearningBoy} />
        <CourseDetail12 img={Programmer} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default WebDev;
